/* Read more for the Selleasy / LogBase upsell popup.

   The popup is injected when it opens, so this watches for it rather than
   scanning once on load. Everything is guarded by a data flag: the observer sees
   the button we insert and runs again, so without the guards it would loop.

   Fails safe by design — the app owns this markup. If it renames its classes,
   nothing here matches and the popup keeps its own behaviour. */
(function () {
  'use strict';

  var PREVIEW = '.lb-product-info-description-preview';
  var MORE = 'Read more';
  var LESS = 'Read less';

  function addToggle(node) {
    if (node.getAttribute('data-fi-readmore') === 'true') return;

    /* While the popup is closed the node has no box, so scrollHeight is 0 and it
       would look as though nothing needs expanding. Leave it unflagged and wait
       for the next mutation instead of deciding too early. */
    if (!node.offsetParent && node.offsetHeight === 0) return;

    node.setAttribute('data-fi-readmore', 'true');

    /* A description short enough to fit gets no button. */
    if (node.scrollHeight - node.clientHeight < 2) return;

    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'fi-lb-readmore';
    button.setAttribute('aria-expanded', 'false');
    button.textContent = MORE;

    button.addEventListener('click', function () {
      var open = node.classList.toggle('fi-lb-open');
      button.setAttribute('aria-expanded', open ? 'true' : 'false');
      button.textContent = open ? LESS : MORE;
    });

    node.insertAdjacentElement('afterend', button);
  }

  /* The app's own "View more details" link is hidden in CSS by its real class
     name, so nothing here needs to go looking for it. */

  var queued = false;

  function scan() {
    queued = false;
    Array.prototype.forEach.call(document.querySelectorAll(PREVIEW), addToggle);
  }

  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(scan);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }

  if ('MutationObserver' in window) {
    new MutationObserver(schedule).observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }
})();
